import React from 'react';
import './Switch.css';

/** The switch's face alone, for a row (or a bar's cell) that is itself the button
 *  (role="switch" on it): the shell Toggle's knob and track, drawn, with no input. */
export function SwitchFace({ on, disabled = false }) {
    return (
        <span className={`ofself-toggle is-face${disabled ? ' is-disabled' : ''}`} aria-hidden="true">
            <span className={`ofself-toggle__track${on ? ' is-on' : ''}`}>
                <span className="ofself-toggle__knob"><i /><i /></span>
            </span>
        </span>
    );
}

export default SwitchFace;
